import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-foreground-200">
      <div className="px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-bold">
                  99
                </div>
                <span className="font-heading text-xl font-bold text-background-50">
                  99漫画
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                推荐类似4399漫画网的免费漫画平台，韩漫日漫国漫全集大全，支持下拉式阅读，轻松追更收藏。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                <a href="/category/korean" className="hover:text-primary-400 transition-colors">漫画分类</a>
              </h4>
              <ul className="space-y-2">
                <li><Link to="/category/korean" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">韩漫</Link></li>
                <li><Link to="/category/japanese" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">日漫</Link></li>
                <li><Link to="/category/chinese" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">国漫</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-2">
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系方式</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">关注我们</h4>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line text-background-50"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 99漫画 - 推荐类似4399漫画网的免费好看漫画平台. All rights reserved.
            </p>
            <div className="flex gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">使用条款</a>
              <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}